import {
  Activity,
  Boxes,
  Building2,
  CreditCard,
  FileClock,
  Fingerprint,
  KeyRound,
  Layers,
  LayoutDashboard,
  Mail,
  Palette,
  RefreshCcwDot,
  ScrollText,
  ShieldCheck,
  Ticket,
  UserRound,
  Users,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  /** i18n key under "nav." */
  labelKey: string
  to: string
  icon: LucideIcon
  /** Renders a small count/badge slot later (sync failures, pending refunds…). */
  end?: boolean
}

export interface NavSection {
  labelKey?: string
  items: NavItem[]
}

/** P2 tenant dashboard sidebar (UI-RECOMMENDATIONS §6.2, mockup "FenceAuth Dashboard"). */
export const DASHBOARD_NAV: NavSection[] = [
  {
    items: [
      { labelKey: 'overview', to: '/dashboard', icon: LayoutDashboard, end: true },
      { labelKey: 'products', to: '/dashboard/products', icon: Boxes },
      { labelKey: 'plans', to: '/dashboard/plans', icon: Layers },
      { labelKey: 'users', to: '/dashboard/users', icon: Users },
      { labelKey: 'invites', to: '/dashboard/invites', icon: Ticket },
      { labelKey: 'organisations', to: '/dashboard/organisations', icon: Building2 },
      { labelKey: 'subscriptions', to: '/dashboard/subscriptions', icon: RefreshCcwDot },
      { labelKey: 'billing', to: '/dashboard/billing', icon: CreditCard },
    ],
  },
  {
    labelKey: 'platformConfig',
    items: [
      { labelKey: 'authSso', to: '/dashboard/auth', icon: ShieldCheck },
      { labelKey: 'apiKeys', to: '/dashboard/api-keys', icon: KeyRound },
      { labelKey: 'branding', to: '/dashboard/branding', icon: Palette },
      { labelKey: 'auditLog', to: '/dashboard/audit', icon: ScrollText },
      { labelKey: 'team', to: '/dashboard/team', icon: UserRound },
    ],
  },
]

/** P3 platform console sidebar (mockups 10a/10e: home · tenants · metrics ·
 *  outbox · fraud · plans · compliance). */
export const PLATFORM_NAV: NavSection[] = [
  {
    items: [
      { labelKey: 'platform.overview', to: '/admin', icon: LayoutDashboard, end: true },
      { labelKey: 'platform.tenants', to: '/admin/tenants', icon: Building2 },
      { labelKey: 'platform.metrics', to: '/admin/metrics', icon: Activity },
      { labelKey: 'platform.outbox', to: '/admin/outbox', icon: Mail },
      { labelKey: 'platform.fraud', to: '/admin/fraud', icon: Fingerprint },
      { labelKey: 'platform.plans', to: '/admin/plans', icon: Layers },
      { labelKey: 'platform.compliance', to: '/admin/compliance', icon: FileClock },
    ],
  },
]
